import classNames from "classnames";
import {
  FunctionComponent,
  MouseEvent,
  ReactElement,
  useCallback,
  useEffect,
} from "react";
import styles from "./Overlay.module.scss";
import { IOverlayProps } from "./types";

export const Overlay: FunctionComponent<IOverlayProps> = (
  props: IOverlayProps
): ReactElement<IOverlayProps> => {
  const { children, className, onClick, onToggle, ...restProps } = props;

  useEffect(() => {
    document.body.classList.add(styles.noScroll);

    return () => {
      document.body.classList.remove(styles.noScroll);
    };
  }, []);

  const doClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      onClick && onClick(event);
      onToggle();
    },
    [onClick]
  );

  return (
    <div
      className={classNames(styles.containerDefault, className)}
      onClick={doClick}
      {...restProps}
    >
      {children}
    </div>
  );
};
